// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/components/shared/require-permission";
import { ApprovalsPage } from "@/features/approvals/approvals-page";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/approvals/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.approvals}>
      <ApprovalsPage />
    </RequirePermission>
  ),
});
